import { render } from "./Income_Statement.vue?vue&type=template&id=01772702&scoped=true"
import script from "./Income_Statement.vue?vue&type=script&lang=js"
export * from "./Income_Statement.vue?vue&type=script&lang=js"

import "./Income_Statement.vue?vue&type=style&index=0&id=01772702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01772702"]])

export default __exports__